import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(legacy)/users/$username')({
	loader: async ({ params }) => {
		throw redirect({
			to: '/u/$username',
			params,
			replace: true,
		})
	},
})
